import { combineReducers } from "redux";

import { RootAction } from "../types";

function modalOpen(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "TOGGLE_PUSH_MODAL_OPEN":
      return !state;
    case "CREATE_PUSH_SUCCESS":
      return false;
    default:
      return state;
  }
}

function isLoading(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case "CREATE_PUSH_REQUEST":
      return true;
    case "CREATE_PUSH_FAILURE":
    case "CREATE_PUSH_SUCCESS":
      return false;
    default:
      return state;
  }
}

export const callsReducer = combineReducers({
  modalOpen,
  isLoading,
});
export default callsReducer;



// WEBPACK FOOTER //
// ./src/reducers/pushReducer.ts